import React, { Component } from "react";

import styles from "./styles.scss";
import PropTypes from "prop-types";
import Autosuggest from "react-autosuggest";
import debounce from "debounce";
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { Paper, MenuItem, Input, InputAdornment } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import CSSModules from "react-css-modules";

/*
    Auto Suggest (Auto complete) wrapper for https://github.com/moroshko/react-autosuggest
    With material design look and feel.
    See default props for specifics.
*/

@CSSModules(styles, { allowMultiple: true })
export default class MaterialAutoSuggest extends Component {
    static defaultProps = {
        suggestions: [],            //Required: Array:      Items to display in auto complete results
        getSuggestions: null,       //Required: Function:   Called whenever input changes, should be used to update the suggestions array. Takes teh current input value as argument
        getSuggestionValue: null,   //Required: Function:   Takes a suggetsion as input and returns a string that should be displayed.
        selectedSuggestion: null,   //Required: Any:        The currently selected suggestion. Used to populate the initial input. 
        onSuggestionSelected: null, //Required: Function:   Called when the user selects a suggestion, with the selected suggestion as the argument
        clearSuggestions: null,     //Required: Function:   Called when the user requests to clear suggestions. 
        debounce: 100,              //Optional: Number:     Debounce in miliseconds for calling the getSuggestions function.
     };
     static propTypes = {
        suggestions: PropTypes.array.isRequired,
        getSuggestions: PropTypes.func.isRequired,
        getSuggestionValue: PropTypes.func.isRequired,  
        selectedSuggestion: PropTypes.any.isRequired,
        onSuggestionSelected: PropTypes.func.isRequired,
        clearSuggestions: PropTypes.func.isRequired,
        debounce: PropTypes.number,
     };

    constructor(props){
        super(props);

        //set teh debounce
        let debounceMs = this.props.debounce;
        if(this.props.debounce !== undefined && this.props.debounce !== null){
            debounceMs = this.props.debounce;
        }
        this.debouncedGetSuggestions = debounce(this.props.getSuggestions, debounceMs);

        //find an initial value for the input.
        let initialInputValue = "";
        if(this.props.getSuggestionValue && this.props.selectedSuggestion){
            initialInputValue = this.props.getSuggestionValue(this.props.selectedSuggestion);
        }

        this.state = {
            inputValue: initialInputValue,
        };
        
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(this);
        this.renderInput = this.renderInput.bind(this);
    }

    render(){
        const materialAutoSuggestInputProps = {
            placeholder: this.props.placeholder,
            value: this.state.inputValue,
            onChange: this.onChange,
            onBlur: this.onBlur,
        };
        return (
            <Autosuggest
                theme={styles}
                suggestions={this.props.suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.props.clearSuggestions}
                getSuggestionValue={this.props.getSuggestionValue}
                onSuggestionSelected={(event, options) => {this.onSuggestionSelected(event, options)}}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                renderSuggestion={this.renderSuggestion}
                renderInputComponent={this.renderInput}
                inputProps={materialAutoSuggestInputProps}
            />
        );
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.suggestions !== this.props.suggestions){
            return true;
        }else if(nextState.inputValue !== this.state.inputValue){
            return true;
        }else if(nextProps.selectedSuggestion !== this.props.selectedSuggestion){
            this.setState({
                inputValue: this.props.getSuggestionValue(nextProps.selectedSuggestion)
            });
            return false;
        }
        return false;
    }

    onBlur = (event) => {
        if(this.props.getSuggestionValue && this.props.selectedSuggestion){
            this.setState({
                inputValue: this.props.getSuggestionValue(this.props.selectedSuggestion),
            });
        }
    };

    onChange = (event, {newValue}) => {
        this.setState({
            inputValue: newValue,
        });
    };

    onSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
        this.props.onSuggestionSelected(suggestion);
        this.setState({
            inputValue: suggestionValue,
        });
    };

    onSuggestionsFetchRequested = ({value, reason}) => {
        if(reason === 'input-changed' || reason === 'input-focused'){
            if(this.props.debounce){
                this.debouncedGetSuggestions(value);
            }else{
                this.props.getSuggestions(value);
            }
		}
    };

    renderInput(inputProps){
        const {ref, ...otherProps } = inputProps;
        return (
            <Input
                className="no-line"
                {...otherProps}
                inputRef={ref}
                endAdornment={
                    <InputAdornment position="end">
                        <ExpandMore />
                    </InputAdornment>
                }
            />
        );
    }

    renderSuggestionsContainer({containerProps, children}){
        return (
            <Paper {...containerProps}>
                {children}
            </Paper>
        );
    }
    
    renderSuggestion(suggestion, {query, isHighlighted}){
        const suggestionValue = this.props.getSuggestionValue(suggestion);
        const matches = match(suggestionValue, query);
        const parts = parse(suggestionValue, matches);
        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {parts.map((part, index) => {
                    return part.highlight ? ( 
                        <span key={String(index)} style={{ fontWeight: 'bold' }}>
                        {part.text}
                        </span>
                    ) : (
                        <strong key={String(index)} style={{ fontWeight: 'normal' }}>
                        {part.text}
                        </strong>
                    );
                    })}
                </div>
            </MenuItem>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AutoSuggest/MaterialAutoSuggest/MaterialAutoSuggest.js